export function getStyles() {
  return {
    screenshotContainer: {
      backgroundColor: '#fafafa',
      borderRadius: '4px',
      marginBottom: '14px',
    },
    stepOneImage: {
    },
    stepTwoImage: {
    },
  };
}
